import React, { useRef, useState, useEffect } from "react";
import { Link, Navigate, useNavigate,useParams } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
 import axios from "axios";
import toast from "react-hot-toast";
import { Helmet } from "react-helmet";

import axiosInstance from "../../axiosInstance";
 
import { Pagination, Navigation, Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { useBlogContext } from "../../fetchdata/BlogContext";
import Select from 'react-select';
import CreateSlug from "../components/extra/CreateSlug";


const Home = () => {

    
  const {
        
    isLayoutLoading,
    layout,AllHomeProducts,isProducts,IsBlogLoading,AllBlogs,AllCategoriess,LocationHeaders
  } = useBlogContext();
const [loading, setloading] = useState(true);

const [Data, setData] = useState([]);
const { slug } = useParams();


const getData = async () => {
  if(slug){
    const modifiedSlug = slug.replace(/-/g, ' '); // This will remove all hyphens

    setloading(true);
    try {
      const { data } = await axiosInstance.get(`/get-catgeory-product?location=${modifiedSlug}`);
      setData(data.categoriesWithProducts || []);
      // Delay the execution of buildScript by 1 secon
      console.log('datadata',data);
    
    }
    catch (error) {
      console.log(error);
      // toast.error("Error fetching Single Blog!");
    } finally {
      setloading(false);
    }
  }
  
};


useEffect(() => {
getData();
window.scrollTo(0, 0);
}, [slug]);

  
const swiperRef = useRef();

const swiperRefLocal = useRef();

const handleMouseEnter = () => {
  swiperRefLocal?.current?.swiper?.autoplay?.stop();
};

const handleMouseLeave = () => {
  swiperRefLocal?.current?.swiper?.autoplay?.start();
};

function formatDate(dateString) {
  const options = { year: 'numeric', month: 'short', day: 'numeric' };
  return new Date(dateString).toLocaleDateString('en-US', options);
}


// Function to render star ratings
const renderStars = (rating) => {
  return Array(5).fill(0).map((_, i) => (
    <i 
      key={i} 
      className={`fa-solid fa-star text-warning ${i < 4 ? 'me-1' : ''}`}
    />
  ));
};

      const [formData, setFormData] = useState({});

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    let newValue = type === "checkbox" ? checked : value;

    if (name === "slug" ) {
      newValue = value
        .toLowerCase() // Convert to lowercase
        .replace(/\s+/g, "-") // Replace spaces with "-"
        .replace(/[^a-z0-9-]/g, ""); // Remove special characters except "-"
    }  
 
   setFormData((prevData) => ({
        ...prevData,
        [name]: newValue,
      }));
   };

 const AllCategoriesOptions = AllCategoriess.map(category => ({
    value: category.slug,
    label: category.title
  }));

  //   const filteredLocations = LocationHeaders.filter((location) =>
  //   location.toLowerCase().includes(searchQuery.toLowerCase())
  // );


   const AllLocationsOptions = LocationHeaders.map(item => ({
    value: item,
    label: item
  }));

  const navigate = useNavigate();

  const SearchChange = (e) => {

   if(formData.locationId && formData.categoryId){
     const loc =  CreateSlug(formData.locationId)
     navigate(`/${loc}/${formData.categoryId}`);
   }else{
    console.log('formData.locationId',formData,formData.locationId,formData.categoryId)
    toast.error('Please choose catgeory and location')
   }

  }
  return (
    <>
      <Header />
 
      <section className="hero-section" id="home">
  <div className="hero-content position-relative overflow-hidden">
    <div className="container">
      <div className="row align-items-center">
        <div className="col-lg-6">
          <div
            className="wow fadeInUp"
            data-wow-duration="1s"
            data-wow-delay=".25s"
          >
            {/*<h1 class="mb-2">Hello this moroocan</h1> */}
            <h1 className="mb-2">
              Hello this moroocan{" "}
              <span className="typed" data-type-text="Carpenters" />
            </h1>
            <p className="mb-3 sub-title">
              We can connect you to the right Service, first time and everytime.
            </p>
            <div className="banner-form bg-white border mb-3">
              <form id="searchForm">
                <div className="d-md-flex align-items-center">
                  <div className="d-flex mb-2 w-100">
                    <span className="input-group-text px-1 bg-white border-0">
                      <i className="ti ti-search" />
                    </span>

                    
<Select
    name="categoryId"
    className="basic-single w-100"
    classNamePrefix="select"
    options={AllCategoriesOptions}
  value={AllCategoriesOptions.find(option => option.value === formData.categoryId)}
    onChange={(selectedOption) => {
    const event = {
      target: {
        name: 'categoryId',
        value: selectedOption.value
      }
    };
    handleChange(event); // Reuse your existing handleChange logic
  }}
    placeholder="Select Catgeory"
    isSearchable
  />
 
     {/* <select
                      className="form-control"
                      id="categoryDropdown"
                      name="categoryId"
                      required=""
                    >
                        <option value="" selected="" disabled="">
                         Search for Service
                         </option>
                      {AllCategoriess.map((catgeory, index) => (
   <option value={catgeory.slug}  key={index}>
   {catgeory.title}
   </option> 
                      ))}
                     
                    </select> */}

                  </div>
                   <div className="d-flex mb-2 w-100">
                    <span className="input-group-text px-1 bg-white border-0">
                      <i className="ti ti-map-pin" />
                    </span>
                                        
<Select
    name="locationId"
    className="basic-single w-100"
    classNamePrefix="select"
    options={AllLocationsOptions}
    value={AllLocationsOptions.find(option => option === formData.locationId)}
     onChange={(selectedOption) => {
    const event = {
      target: {
        name: 'locationId',
        value: selectedOption.value
      }
    };
    handleChange(event); // Reuse your existing handleChange logic
  }}

    placeholder="Select Location"
    isSearchable
  />
 
                  </div>
                  <div className="mb-2 ms-2">
                    <button
                      type="button"
                      className="btn btn-linear-primary d-inline-flex align-items-center w-100"
                      onClick={SearchChange}
                    >
                      <i className="feather-search me-2" />
                      Search
                    </button>
                  </div>
                </div>
              </form>
              <img
                src="/assets/img/bg/bg-06.svg"
                alt="img"
                className="shape-06 round-animate"
              />
            </div>
            {/* <div className="d-flex align-items-center flex-wrap">
              <h6 className="mb-2 me-2 fw-medium">Popular Searches</h6>
              <a
                href="/services/carwash"
                className="badge badge-dark-transparent fs-14 fw-normal mb-2 me-2"
              >
                Car Wash
              </a>
              <a
                href="/services/construction"
                className="badge badge-dark-transparent fs-14 fw-normal mb-2 me-2"
              >
                Construction
              </a>
              <a
                href="/services/removal"
                className="badge badge-dark-transparent fs-14 fw-normal mb-2 me-2"
              >
                Removal
              </a>
            </div> */}
            <div className="d-flex align-items-center flex-wrap banner-info">
              <div className="d-flex align-items-center me-4 mt-4">
                <img
                  src="/assets/img/icons/success-01.svg"
                  alt="icon"
                />
                <div className="ms-2">
                  <h6>215,292 +</h6>
                  <p>Verified Providers</p>
                </div>
              </div>
              <div className="d-flex align-items-center me-4 mt-4">
                <img
                  src="/assets/img/icons/success-02.svg"
                  alt="icon"
                />
                <div className="ms-2">
                  <h6>90,000+</h6>
                  <p>Services Completed</p>
                </div>
              </div>
              <div className="d-flex align-items-center me-4 mt-4">
                <img
                  src="/assets/img/icons/success-03.svg"
                  alt="icon"
                />
                <div className="ms-2">
                  <h6>2,390,968 </h6>
                  <p>Reviews Globally</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="banner-img wow fadeInUp"
          data-wow-duration="1s"
          data-wow-delay=".25s"
        >
          <img
            src={layout.slider_img}
            alt="img"
            className="img-fluid animation-float"
          />
        </div>
      </div>
    </div>
    <div className="hero-image">
      <div className="d-inline-flex bg-white p-2 rounded align-items-center shape-01 floating-x">
        <span className="avatar avatar-md bg-warning rounded-circle me-2">
          <i className="ti ti-star-filled" />
        </span>
        <span>
          4.9 / 5<small className="d-block">(255 reviews)</small>
        </span>
        <i className="border-edge" />
      </div>
      <div className="d-inline-flex bg-white p-2 rounded align-items-center shape-02 floating-x">
        <span className="me-2">
          <img
            src="/assets/img/icons/tick-banner.svg"
            alt=""
          />
        </span>
        <p className="fs-12 text-dark mb-0">300 Booking Completed</p>
        <i className="border-edge" />
      </div>
      <img
        src="/assets/img/bg/bg-03.svg"
        alt="img"
        className="shape-03"
      />
      <img
        src="/assets/img/bg/bg-04.svg"
        alt="img"
        className="shape-04"
      />
      <img
        src="/assets/img/bg/bg-05.svg"
        alt="img"
        className="shape-05"
      />
    </div>
  </div>
  <div
    className="modal fade wallet-modal home-modal"
    id="add-offer"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabIndex={-1}
    aria-hidden="true"
  >
    <div className="modal-dialog">
      <div className="modal-content" id="modalBody">
        <div className="modal-header d-flex align-items-center justify-content-between border-0">
          <h5>Find the Best Professionals</h5>
          <a
            href="javascript:void(0);"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <i className="ti ti-circle-x-filled fs-24" />
          </a>
        </div>
        <form action="provider-offers.html">
          <div className="modal-body " id="modal-body-content"></div>
        </form>
        <div className="modal-footer">
          <button type="button" id="back-btn" className="btn btn-secondary">
            Back
          </button>
          <button type="submit" id="continue-btn" className="btn btn-dark">
            Continue
          </button>
        </div>
      </div>
    </div>
  </div>
</section>

<section className="section category-section bg-white">
  <div className="container">
    <div className="row justify-content-center">
      <div
        className="col-lg-6 text-center wow fadeInUp"
        data-wow-delay="0.2s"
        style={{
          visibility: "visible",
          animationDelay: "0.2s",
          animationName: "fadeInUp"
        }}
      >
        <div className="section-header text-center">
          <h2 className="mb-1">
         Our
            <span className="text-linear-primary"> Category</span>
          </h2>
          {/* <p className="sub-title">
            Service categories help organize and structure the offerings on a
            marketplace, making it easier for users to find what they need.
          </p> */}
        </div>
      </div>
    </div>
    <div className="row g-4 row-cols-lg-6 row-cols-md-4 row-cols-sm-3 row-cols-2 justify-content-center">

      {isLayoutLoading
                   ? Array.from({ length: 9 }).map((_, index) => (
                        <div
                         className="col-md-4 col-6 skeleton mb-2 shadow" 
                         style={{
                            height: "60px", 
                           transform:'scale(0.95)'
                         }}
                       ></div>
                    ))
                   : layout.trending_product_banner && (
                     <>
                       {layout.trending_product_banner.map((image, index) => (

<div className="col d-flex">
<div
  className="category-item text-center flex-fill wow fadeInUp"
  data-wow-delay="0.2s"
  style={{
    visibility: "visible",
    animationDelay: "0.2s",
    animationName: "fadeInUp"
  }}
>
  <div className="mx-auto mb-3">
    <img
       src={image.imageInput}
       alt={image.imageTITInput} 
      className="img-fluid"
     
    />
  </div>
  <h6 className="fs-14 mb-1"> {image.imageTITInput}</h6>
   <Link to={image.imageUrlInput}
    className="link-primary text-decoration-underline fs-14"
  >
    View All
  </Link>
</div>
</div> 
                        ))}
                     </>
                   )}

  
   
    </div>
    <div className="row d-none">
      <div className="col-md-12">
        <div
          className="text-center view-all wow fadeInUp"
          data-wow-delay="0.2s"
          style={{
            visibility: "visible",
            animationDelay: "0.2s",
            animationName: "fadeInUp"
          }}
        >
          <a
            href="/categories"
            className="btn btn-dark"
          >
            View All
            <i className="ti ti-arrow-right ms-2" />
          </a>
        </div>
      </div>
    </div>
  </div>
</section>


 <section className="section service-section">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-6 text-center wow fadeInUp" data-wow-delay="0.2s">
            <div className="section-header text-center">
              <h2 className="mb-1">
                Our Latest<span className="text-linear-primary"> Services</span>
              </h2>
              <p className="sub-title">
                Each listing is designed to be clear and concise, providing customers
              </p>
            </div>
          </div>
        </div>
        
        <div 
          className="service-slider"
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <Swiper
            slidesPerView={1}
            spaceBetween={30}
            pagination={{
              clickable: true,
            }}
            navigation={true}
            breakpoints={{
              640: {
                slidesPerView: 1,
              },
              768: {
                slidesPerView: 2,
              },
              1024: {
                slidesPerView: 3,
              },
            }}
            ref={swiperRefLocal}
            autoplay={{
              delay: 1500,
              pauseOnMouseEnter: true,
            }}
            loop={true}
            modules={[Pagination, Navigation, Autoplay]}
            className="mySwiper"
          >
             {isProducts ? (Array.from({ length: 7 }).map((_, index) => (
                <SwiperSlide key={index} >
                  <div
                    className="card-1 skeleton"
                    style={{ height: 371, borderRadius: 10 }}
                  ></div>

                </SwiperSlide>
              ))
              ) : (layout.latest_product && (
                <>
                  {AllHomeProducts.length !== 0 && AllHomeProducts.map((product, index) => {
 


                    const Images = product.images || [];

                    return (

                      layout.trending_product.includes(product._id) && (<>

<SwiperSlide key={index}>
                                  <div className="service-item wow fadeInUp" data-wow-delay="0.2s">
                                    <div className="service-img">
                                      <Swiper
                                        pagination={true}
                                        navigation={true}
                                        spaceBetween={0}
                                        ref={swiperRefLocal}
                                        autoplay={{
                                          delay: 1500,
                                          pauseOnMouseEnter: true,
                                        }}
                                        loop={true}
                                        modules={[Pagination, Navigation, Autoplay]}
                                        className="img-slider"
                                      >
                                        {Images.map((image, index) => (
                                          <SwiperSlide key={index}>
                                            
                                            <div className="slide-images featured-image">
                                              <Link >
                                                <img
                                                  src={image}
                                                  className="img-fluid w-100"
                                                  alt="img"
                                                 style={{aspectRatio:'1/1',objectFit:'cover'}}

                                                />
                                              </Link>
                                            </div>
                                          </SwiperSlide>
                                        ))}
                                      </Swiper>
                                      <div className="trend-icon">
                                        <span className="bg-success">
                                          <i className="feather-trending-up" />
                                        </span>
                                      </div>
                                      {/* <div className="fav-item">
                                        <a href="javascript:void(0);" className="fav-icon">
                                          <i className="ti ti-heart" />
                                        </a>
                                      </div> */}
                                    </div>
                                    <div className="service-content bg-white">
                                      <h6 className="text-truncate mb-1">
                                        <Link to={`/product/${product.slug}`} >
                                        {product.title}
                                        </Link>
                                      </h6>
                                      <div className="d-flex align-items-center justify-content-between">
                                        {product.salePrice !== 0 || product.regularPrice !== 0 ?
                  <p className="fw-medium fs-14 mb-0">Service starts at @ <b className="text-black"> ₹{product.salePrice} </b></p>
                : 
                <p className="fw-medium fs-14 mb-0 text-danger">Price On Request</p>
                
                                        }
                                        {/* <span className="d-inline-flex align-items-center fs-14">
                                          <i className="ti ti-star-filled text-warning me-1" />
                                          {service.rating}
                                        </span> */}
                                      </div>
                                    </div>
                                  </div>
                                </SwiperSlide>
                                
 
                      </>)


                    )
                  }
                  )}

</>
              )
              )}

           
          </Swiper>
        </div>

        <div className="row">
          <div className="col-md-12">
            <div className="text-center wow fadeInUp" data-wow-delay="0.2s">
              <a href="/services" className="btn btn-dark">
                View All
                <i className="ti ti-arrow-right ms-2" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section className="section bg-white mt-4 pt-4">
  <div className="container">
    <div className="work-section bg-black m-0">
      <div className="row align-items-center bg-01">
        <div
          className="col-md-12 wow fadeInUp"
          data-wow-delay="0.2s"
          style={{
            visibility: "visible",
            animationDelay: "0.2s",
            animationName: "fadeInUp"
          }}
        >
          <div className="section-header text-center">
            <h2 className="mb-1 text-white">
              How it <span className="text-linear-primary">works</span>
            </h2>
            {/* <p className="text-light">
              Each listing is designed to be clear and concise, providing
              customers
            </p> */}
          </div>
        </div>
      </div>
      <div className="row gx-0 gy-4">
        <div className="col-lg-12 d-flex">
          <div className=" text-center flex-fill">
            <div className="mb-3">
              <img
                src="/assets/img/icons/work-01.svg"
                alt="img"
                style={{ display: "none" }}
              />
            </div>
            <p />
            <div className="row gx-0 gy-4"> 
            {layout.latest_product_banner && layout.latest_product_banner.length !== 0 &&
  layout.latest_product_banner.map((product, index) => (
    <div className="col-lg-4 d-flex" key={index}>
      <div className="work-item text-center flex-fill">
        <div className="mb-3">
          <img src={product.imageInput} alt="img" />
        </div>
        <h6 className="text-white mb-2">{product.imageTITInput}</h6>
        <p>{product.imageParaInput}</p>
      </div>
    </div>
  ))
}

           
            </div>
            <p />
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

{/* <section className="section pt-0 bg-white">
  <div className="container">
    <div className="provider-sec">
      <div className="row justify-content-center">
        <div
          className="col-lg-12 text-center wow fadeInUp"
          data-wow-delay="0.2s"
          style={{
            visibility: "visible",
            animationDelay: "0.2s",
            animationName: "fadeInUp"
          }}
        >
          <div className="section-header text-center">
            <h2 className="mb-1">
              Popular <span className="text-linear-primary">Providers</span>
            </h2>
            <p className="sub-title">
              Each listing is designed to be clear and concise, providing
              customers
            </p>
          </div>
        </div>
      </div>
      <div className="row gx-0">
        <div className="col-xl-3 col-lg-4 col-md-6 d-flex">
          <div className="provider-item flex-fill">
            <div className="d-flex align-items-center">
              <a href="/user/providerdetails" className=""></a>
              <a
                href="#"
                data-bs-toggle="modal"
                data-bs-target="#login-modal"
                className="provider-details-link avatar avatar-xl me-2"
              >
                <img
                  src="https://app.truelysell.com/storage/profile/e042680b-ceaa-4f4c-8932-f001e8a9bc17_1744431481.jpg"
                  alt="Profile Image"
                  className="rounded-circle"
                />
              </a>
              <div>
                <h6>
                  <a
                    href="/user/providerdetails"
                    data-provider-id={81}
                    className="provider-details-link"
                  >
                    Demo provider
                  </a>
                </h6>
                <p className="fs-14 mb-0">
                  <i className="ti ti-star-filled text-warning me-1" />
                  3.2 (26 Reviews)
                </p>
                <p className="mb-0">27 Services</p>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 d-flex">
          <div className="provider-item flex-fill">
            <div className="d-flex align-items-center">
              <a href="/user/providerdetails" className=""></a>
              <a
                href="#"
                data-bs-toggle="modal"
                data-bs-target="#login-modal"
                className="provider-details-link avatar avatar-xl me-2"
              >
                <img
                  src="https://app.truelysell.com/assets/img/user-default.jpg"
                  alt="Default Image"
                  className="rounded-circle"
                />
              </a>
              <div>
                <h6>
                  <a
                    href="/user/providerdetails"
                    data-provider-id={199}
                    className="provider-details-link"
                  >
                    Kbh narola
                  </a>
                </h6>
                <p className="fs-14 mb-0">
                  <i className="ti ti-star-filled text-warning me-1" />
                  0.0 (0 Reviews)
                </p>
                <p className="mb-0">1 Services</p>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 d-flex">
          <div className="provider-item flex-fill">
            <div className="d-flex align-items-center">
              <a href="/user/providerdetails" className=""></a>
              <a
                href="#"
                data-bs-toggle="modal"
                data-bs-target="#login-modal"
                className="provider-details-link avatar avatar-xl me-2"
              >
                <img
                  src="https://app.truelysell.com/assets/img/user-default.jpg"
                  alt="Default Image"
                  className="rounded-circle"
                />
              </a>
              <div>
                <h6>
                  <a
                    href="/user/providerdetails"
                    data-provider-id={235}
                    className="provider-details-link"
                  >
                    Anisha vivek
                  </a>
                </h6>
                <p className="fs-14 mb-0">
                  <i className="ti ti-star-filled text-warning me-1" />
                  2.0 (3 Reviews)
                </p>
                <p className="mb-0">1 Services</p>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 d-flex">
          <div className="provider-item flex-fill">
            <div className="d-flex align-items-center">
              <a href="/user/providerdetails" className=""></a>
              <a
                href="#"
                data-bs-toggle="modal"
                data-bs-target="#login-modal"
                className="provider-details-link avatar avatar-xl me-2"
              >
                <img
                  src="https://app.truelysell.com/assets/img/user-default.jpg"
                  alt="Default Image"
                  className="rounded-circle"
                />
              </a>
              <div>
                <h6>
                  <a
                    href="/user/providerdetails"
                    data-provider-id={298}
                    className="provider-details-link"
                  >
                    Prov on1
                  </a>
                </h6>
                <p className="fs-14 mb-0">
                  <i className="ti ti-star-filled text-warning me-1" />
                  0.0 (0 Reviews)
                </p>
                <p className="mb-0">1 Services</p>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 d-flex">
          <div className="provider-item flex-fill">
            <div className="d-flex align-items-center">
              <a href="/user/providerdetails" className=""></a>
              <a
                href="#"
                data-bs-toggle="modal"
                data-bs-target="#login-modal"
                className="provider-details-link avatar avatar-xl me-2"
              >
                <img
                  src="https://app.truelysell.com/assets/img/user-default.jpg"
                  alt="Default Image"
                  className="rounded-circle"
                />
              </a>
              <div>
                <h6>
                  <a
                    href="/user/providerdetails"
                    data-provider-id={23}
                    className="provider-details-link"
                  >
                    Natalie brown
                  </a>
                </h6>
                <p className="fs-14 mb-0">
                  <i className="ti ti-star-filled text-warning me-1" />
                  0.0 (0 Reviews)
                </p>
                <p className="mb-0">0 Services</p>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 d-flex">
          <div className="provider-item flex-fill">
            <div className="d-flex align-items-center">
              <a href="/user/providerdetails" className=""></a>
              <a
                href="#"
                data-bs-toggle="modal"
                data-bs-target="#login-modal"
                className="provider-details-link avatar avatar-xl me-2"
              >
                <img
                  src="https://app.truelysell.com/assets/img/user-default.jpg"
                  alt="Default Image"
                  className="rounded-circle"
                />
              </a>
              <div>
                <h6>
                  <a
                    href="/user/providerdetails"
                    data-provider-id={35}
                    className="provider-details-link"
                  >
                    Brian cooper
                  </a>
                </h6>
                <p className="fs-14 mb-0">
                  <i className="ti ti-star-filled text-warning me-1" />
                  0.0 (0 Reviews)
                </p>
                <p className="mb-0">0 Services</p>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 d-flex">
          <div className="provider-item flex-fill">
            <div className="d-flex align-items-center">
              <a href="/user/providerdetails" className=""></a>
              <a
                href="#"
                data-bs-toggle="modal"
                data-bs-target="#login-modal"
                className="provider-details-link avatar avatar-xl me-2"
              >
                <img
                  src="https://app.truelysell.com/assets/img/user-default.jpg"
                  alt="Default Image"
                  className="rounded-circle"
                />
              </a>
              <div>
                <h6>
                  <a
                    href="/user/providerdetails"
                    data-provider-id={36}
                    className="provider-details-link"
                  >
                    Smith lauren
                  </a>
                </h6>
                <p className="fs-14 mb-0">
                  <i className="ti ti-star-filled text-warning me-1" />
                  0.0 (0 Reviews)
                </p>
                <p className="mb-0">0 Services</p>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 d-flex">
          <div className="provider-item flex-fill">
            <div className="d-flex align-items-center">
              <a href="/user/providerdetails" className=""></a>
              <a
                href="#"
                data-bs-toggle="modal"
                data-bs-target="#login-modal"
                className="provider-details-link avatar avatar-xl me-2"
              >
                <img
                  src="https://app.truelysell.com/assets/img/user-default.jpg"
                  alt="Default Image"
                  className="rounded-circle"
                />
              </a>
              <div>
                <h6>
                  <a
                    href="/user/providerdetails"
                    data-provider-id={37}
                    className="provider-details-link"
                  >
                    Amanda harris
                  </a>
                </h6>
                <p className="fs-14 mb-0">
                  <i className="ti ti-star-filled text-warning me-1" />
                  0.0 (0 Reviews)
                </p>
                <p className="mb-0">0 Services</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="text-center view-all wow fadeInUp"
        data-wow-delay="0.2s"
        style={{
          visibility: "visible",
          animationDelay: "0.2s",
          animationName: "fadeInUp"
        }}
      >
        <a
          href="/user/providerlist"
          className="btn btn-dark"
        >
          View All
          <i className="ti ti-arrow-right ms-2" />
        </a>
      </div>
    </div>
  </div>
</section> */}



<section className="section service-section">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-6 text-center wow fadeInUp" data-wow-delay="0.2s">
            <div className="section-header text-center">
              <h2 className="mb-1">
                Our Trending<span className="text-linear-primary"> Services</span>
              </h2>
              <p className="sub-title">
                Each listing is designed to be clear and concise, providing customers
              </p>
            </div>
          </div>
        </div>
        
        <div 
          className="service-slider"
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <Swiper
            slidesPerView={1}
            spaceBetween={30}
            pagination={{
              clickable: true,
            }}
            navigation={true}
            breakpoints={{
              640: {
                slidesPerView: 1,
              },
              768: {
                slidesPerView: 2,
              },
              1024: {
                slidesPerView: 3,
              },
            }}
            ref={swiperRefLocal}
            autoplay={{
              delay: 1500,
              pauseOnMouseEnter: true,
            }}
            loop={true}
            modules={[Pagination, Navigation, Autoplay]}
            className="mySwiper"
          >
             {isProducts ? (Array.from({ length: 7 }).map((_, index) => (
                <SwiperSlide key={index} >
                  <div
                    className="card-1 skeleton"
                    style={{ height: 371, borderRadius: 10 }}
                  ></div>

                </SwiperSlide>
              ))
              ) : (layout.trending_product && (
                <>
                  {AllHomeProducts.length !== 0 && AllHomeProducts.map((product, index) => {
 


                    const Images = product.images || [];

                    return (

                      layout.trending_product.includes(product._id) && (<>

<SwiperSlide key={index}>
                                  <div className="service-item wow fadeInUp" data-wow-delay="0.2s">
                                    <div className="service-img">
                                      <Swiper
                                        pagination={true}
                                        navigation={true}
                                        spaceBetween={0}
                                        ref={swiperRefLocal}
                                        autoplay={{
                                          delay: 1500,
                                          pauseOnMouseEnter: true,
                                        }}
                                        loop={true}
                                        modules={[Pagination, Navigation, Autoplay]}
                                        className="img-slider"
                                      >
                                        {Images.map((image, index) => (
                                          <SwiperSlide key={index}>
                                            
                                            <div className="slide-images featured-image">
                                              <Link >
                                                <img
                                                  src={image}
                                                  className="img-fluid w-100"
                                                  alt="img"
                                                  style={{aspectRatio:'1/1',objectFit:'cover'}}
                                                />
                                              </Link>
                                            </div>
                                          </SwiperSlide>
                                        ))}
                                      </Swiper>
                                      <div className="trend-icon">
                                        <span className="bg-success">
                                          <i className="feather-trending-up" />
                                        </span>
                                      </div>
                                      {/* <div className="fav-item">
                                        <a href="javascript:void(0);" className="fav-icon">
                                          <i className="ti ti-heart" />
                                        </a>
                                      </div> */}
                                    </div>
                                    <div className="service-content bg-white">
                                      <h6 className="text-truncate mb-1">
                                        <Link to={`/product/${product.slug}`} >
                                        {product.title}
                                        </Link>
                                      </h6>
                                      <div className="d-flex align-items-center justify-content-between">
                                        {product.salePrice !== 0 || product.regularPrice !== 0 ?
                  <p className="fw-medium fs-14 mb-0">Service starts at @ <b className="text-black"> ₹{product.salePrice} </b></p>
                : 
                <p className="fw-medium fs-14 mb-0 text-danger">Price On Request</p>
                
                                        }
                                        {/* <span className="d-inline-flex align-items-center fs-14">
                                          <i className="ti ti-star-filled text-warning me-1" />
                                          {service.rating}
                                        </span> */}
                                      </div>
                                    </div>
                                  </div>
                                </SwiperSlide>
                                
 
                      </>)


                    )
                  }
                  )}

</>
              )
              )}

           
          </Swiper>
        </div>

        <div className="row">
          <div className="col-md-12">
            <div className="text-center wow fadeInUp" data-wow-delay="0.2s">
              <a href="/services" className="btn btn-dark">
                View All
                <i className="ti ti-arrow-right ms-2" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>

 

<section className="section testimonial-section bg-white">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-6 text-center wow fadeInUp" data-wow-delay="0.2s">
            <div className="section-header text-center">
              <h2 className="mb-1">
                Genuine reviews from
                <span className="text-linear-primary"> Customers</span>
              </h2>
              {/* <p className="sub-title">
                Each listing is designed to be clear and concise, providing customers
              </p> */}
            </div>
          </div>
        </div>

        <div 
          className="testimonial-slider"
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <Swiper
            slidesPerView={1}
            spaceBetween={30}
            pagination={{
              clickable: true,
            }}
            navigation={true}
            breakpoints={{
              640: {
                slidesPerView: 2,
              },
              1024: {
                slidesPerView: 3,
              },
            }}
            ref={swiperRef}
            autoplay={{
              delay: 2500,
              pauseOnMouseEnter: true,
            }}
            loop={true}
            modules={[Pagination, Navigation, Autoplay]}
            className="mySwiper"
          >

{layout.latest_product_carousal && layout.latest_product_carousal.length !== 0 &&
  layout.latest_product_carousal.map((product, index) => (
    <SwiperSlide key={index}>
    <div className="testimonial-item wow fadeInUp" data-wow-delay="0.2s">
      <div className="d-flex align-items-center mb-3">
        {renderStars(4)}
      </div>
      <p className="mb-2 text-truncate-testimonial">
      {product.imageUrlInput}
      </p>
      <div className="d-flex align-items-center justify-content-between">
        <div className="d-flex align-items-center overflow-hidden">
          <span className="avatar avatar-lg flex-shrink-0">
            <img
              src={product.imageInput}
              className="img-fluid rounded-circle"
              alt={product.imageTITInput}
            />
          </span>
          <h6 className="text-truncate ms-2">{product.imageTITInput}</h6>
        </div>
      
      </div>
    </div>
  </SwiperSlide>
  
  ))
}

 
          </Swiper>
        </div>

        <div className="text-center wow fadeInUp" data-wow-delay="0.2s">
          <h6 className="mb-2">
            Each listing is designed to be clear and concise, providing customers
          </h6>
          <p>
            <span className="text-dark fw-medium">Excellent</span>
            {Array(5).fill(0).map((_, i) => (
              <img
                key={i}
                src="https://app.truelysell.com/front/img/icons/star-01.svg"
                className="img-fluid"
                alt="star"
              />
            ))}
            <span className="fs-14">Based on 8 reviews</span>
          </p>
        </div>
      </div>
    </section>

    <section className="section provide-section bg-black">
  <div className="container">
    <div className="row align-items-center">
      <div
        className="col-md-6 wow fadeInUp"
        data-wow-delay="0.2s"
        style={{
          visibility: "visible",
          animationDelay: "0.2s",
          animationName: "fadeInUp"
        }}
      >
        <div className="section-header mb-md-0 mb-3">
          <p className="sub-title fw-medium text-light mb-1">
            Become a Provider
          </p>
          <h2 className="text-white">
            Post your service in a minute
            <span className="text-linear-primary" />
          </h2>
        </div>
      </div>
      <div
        className="col-md-6 text-md-end wow fadeInUp"
        data-wow-delay="0.2s"
        style={{
          visibility: "visible",
          animationDelay: "0.2s",
          animationName: "fadeInUp"
        }}
      >
        <a
          href="javascript:void(0);"
          data-bs-toggle="modal"
          data-bs-target="#provider"
          className="btn btn-linear-primary"
          
        >
          <i className="ti ti-user-filled me-2" />
          Join Us
        </a>
      </div>
    </div>
  </div>
  <div className="provider-bg1">
    <img
      src="https://app.truelysell.com/front/img/bg/provide-bg-01.svg"
      className="img-fluid"
      alt="img"
    />
  </div>
  <div className="provider-bg2">
    <img
      src="https://app.truelysell.com/front/img/bg/provide-bg-02.svg"
      className="img-fluid"
      alt="img"
    />
  </div>
</section>


<section className="section blog-section bg-white">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-6 text-center wow fadeInUp" data-wow-delay="0.2s">
            <div className="section-header text-center">
              <h2 className="mb-1">
                Checkout our Recent<span className="text-linear-primary"> Blogs</span>
              </h2>
              <p className="sub-title">Each listing is designed to be clear and concise, providing customers</p>
            </div>
          </div>
        </div>

        <div 
          className="blog-slider"
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <Swiper
            slidesPerView={1}
            spaceBetween={30}
            pagination={{
              clickable: true,
            }}
            navigation={true}
            breakpoints={{
              576: {
                slidesPerView: 2,
              },
              768: {
                slidesPerView: 3,
              },
              992: {
                slidesPerView: 3,
              }
            }}
            ref={swiperRef}
            autoplay={{
              delay: 3000,
              pauseOnMouseEnter: true,
            }}
            loop={true}
            modules={[Pagination, Navigation, Autoplay]}
            className="mySwiper"
          >

{IsBlogLoading ? (
                  <>
                     

                      {Array.from({ length: 4 }).map((_, index) => (
                <SwiperSlide key={index}>
                        <div className="blog-column-end col-md-12 mb-3">
                          <p className="skeleton" style={{ height: 219, borderRadius: 5, aspectRatio: "2/1" }} >  </p>
                          <p className="skeleton" style={{ width: "50%", borderRadius: 5 }} >  </p>
                          <p className="skeleton mb-2" style={{ width: "100%", borderRadius: 5 }} >  </p>
                          <p className="skeleton mb-2" style={{ width: 100, height: 10, borderRadius: 5 }} >  </p>

                          <p className="skeleton" style={{ width: 100, height: 20, borderRadius: 5 }} >  </p>
                          <p className="skeleton" style={{ width: '100%', height: 50, borderRadius: 5 }} >  </p>

                       </div>
                       </SwiperSlide> 
                      ))}
                  
                    </>
                ) : (AllBlogs.length !== 0 && AllBlogs.map(blog => (

                  <>
                <SwiperSlide  key={blog._id} >

                <div className="blog-item wow fadeInUp" data-wow-delay="0.2s">
                  <div className="blog-img blog-details">
                    <Link  to={`/blog/${blog._id}`} >
                      <img src={blog.image} className="img-fluid w-100" style={{ aspectRatio: "2/1", objectFit: "cover" }} alt={blog.title} />
                    </Link>
                  </div>
                  <div className="blog-content">
                    <p className="fs-14 fw-meium text-gray-9 d-inline-flex align-items-center mb-2">
                      <i className="ti ti-circle-filled fs-6 mx-1"></i> {formatDate(blog.createdAt)}
                    </p>
                    <h6 className="text-truncate mb-2">
                      <Link  to={`/blog/${blog._id}`} > {blog.title} </Link>
                    </h6>
                    <p className="two-line-ellipsis mb-3"> {blog.metaDescription} </p>
                  </div>
                </div>
                
                

                    </SwiperSlide> 

                  </>

                ))
                )}

           
          </Swiper>
        </div>

        <div className="text-center wow fadeInUp" data-wow-delay="0.2s">
          <a href="/blogs" className="btn btn-dark">
            View All<i className="ti ti-arrow-right ms-2"></i>
          </a>
        </div>
      </div>
    </section>

    <section className="section business-section bg-black">
  <div className="container">
    <div className="row align-items-center bg-01">
      <div
        className="col-md-6 wow fadeInUp"
        data-wow-delay="0.2s"
        style={{
          visibility: "visible",
          animationDelay: "0.2s",
          animationName: "fadeInUp"
        }}
      >
        <div className="section-header mb-md-0 mb-4">
          <h2 className="text-white display-4">
          {layout.collection_heading}
            
          </h2>
          <p className="text-light">
          {layout.collection_paragraph}
          </p>
          <Link to={layout.collection_url}
           
            data-bs-toggle="modal"
            data-bs-target="#provider"
            className="btn btn-linear-primary"
          >
            <i className="ti ti-user-filled me-2" />
            Join Us
          </Link>
        </div>
      </div>
      <div
        className="col-md-6 text-md-end wow fadeInUp"
        data-wow-delay="0.2s"
        style={{
          visibility: "visible",
          animationDelay: "0.2s",
          animationName: "fadeInUp"
        }}
      >
        <div className="business-img">
          <img
            src={layout.collection_img}
            className="img-fluid"
            alt="img"
          />
        </div>
      </div>
    </div>
  </div>
</section>



    {/* <section className="section faq-section">
    <div className="container">
      <div className="section-header text-center mb-4">
        <h2 className="mb-1">
          FAQ
          <span className="text-linear-primary" />
        </h2>
        <p className="sub-title">
          Each listing is designed to be clear and concise, providing customers
        </p>
      </div>
      <div className="accordion accordion-flush" id="accordionFlushExample">
        <div className="accordion-item">
          <h2 className="accordion-header">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#flush-collapse0"
              aria-expanded="false"
              aria-controls="flush-collapse0"
            >
              What is your company’s purpose?
            </button>
          </h2>
          <div
            id="flush-collapse0"
            className="accordion-collapse collapse"
            data-bs-parent="#accordionFlushExample"
          >
            <div className="accordion-body">
              FAQ pages must be kept concise and easy to navigate. A desirable
              FAQ page is well organized and allows customers and potential
              customers to find all the information they need in the easiest
              way.
            </div>
          </div>
        </div>
        <div className="accordion-item">
          <h2 className="accordion-header">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#flush-collapse1"
              aria-expanded="false"
              aria-controls="flush-collapse1"
            >
              How do users contact customer service or support?
            </button>
          </h2>
          <div
            id="flush-collapse1"
            className="accordion-collapse collapse"
            data-bs-parent="#accordionFlushExample"
          >
            <div className="accordion-body">
              Categorizing your questions will help customers zero in on the
              information they’re looking for without having to sift through a
              long list of random questions.
            </div>
          </div>
        </div>
        <div className="accordion-item">
          <h2 className="accordion-header">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#flush-collapse2"
              aria-expanded="false"
              aria-controls="flush-collapse2"
            >
              Where can user buy your products?
            </button>
          </h2>
          <div
            id="flush-collapse2"
            className="accordion-collapse collapse"
            data-bs-parent="#accordionFlushExample"
          >
            <div className="accordion-body">
              Therefore, make it easier and faster for users to find help to
              specific questions by incorporating a search bar on your FAQ page.
            </div>
          </div>
        </div>
        <div className="accordion-item">
          <h2 className="accordion-header">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#flush-collapse3"
              aria-expanded="false"
              aria-controls="flush-collapse3"
            >
              Does it support shared hosting
            </button>
          </h2>
          <div
            id="flush-collapse3"
            className="accordion-collapse collapse"
            data-bs-parent="#accordionFlushExample"
          >
            <div className="accordion-body">
              Yes, our application support shared hosting.
            </div>
          </div>
        </div>
      </div>
    </div>
  </section> */}

      <Footer />
    </>
  );
};

export default Home;
